import { render } from "./OpcaoEdicao.vue?vue&type=template&id=6f03f9ea&scoped=true&ts=true"
import script from "./OpcaoEdicao.vue?vue&type=script&lang=ts"
export * from "./OpcaoEdicao.vue?vue&type=script&lang=ts"

import "./OpcaoEdicao.vue?vue&type=style&index=0&id=6f03f9ea&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f03f9ea"]])

export default __exports__